<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.primaryPattern"]);

const color = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.primaryPattern"].value;
});
</script>

<template>
  <!-- 不设置 width="24" height="24" 自适应父元素 -->
  <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      d="M15.4547 11.0552C15.4547 11.395 15.6848 11.6249 16.0249 11.6249C16.365 11.6249 16.5951 11.395 16.5951 11.0552C16.5951 9.18643 15.0746 7.66741 13.2039 7.66741C12.8637 7.66741 12.6337 7.89726 12.6337 8.23704C12.6337 8.57682 12.8637 8.80667 13.2039 8.80667C14.4543 8.81667 15.4547 9.846 15.4547 11.0552ZM17.7356 11.0552C17.7356 11.395 17.9656 11.6249 18.3058 11.6249C18.6459 11.6249 18.876 11.395 18.876 11.0552C18.876 7.97721 16.355 5.41885 13.2339 5.41885C12.8938 5.42885 12.6637 5.6587 12.6637 5.99848C12.6637 6.33826 12.8938 6.56811 13.2339 6.56811C15.6748 6.56811 17.7356 8.58681 17.7356 11.0552ZM10.1127 9.0765C10.7229 8.46689 10.803 7.5175 10.2228 6.82795L8.4721 4.62936C7.90189 3.90982 6.83149 3.7899 6.11122 4.35953C6.07121 4.43948 5.99118 4.43948 5.99118 4.47946L4.47061 5.99848C3.02007 7.44755 5.08084 11.405 8.85224 15.1726C12.6237 18.9402 16.5151 20.9589 17.9656 19.5498L19.4862 18.0307C20.1765 17.3412 20.1765 16.2819 19.4862 15.6723L19.3762 15.5623L17.1653 13.8134C16.4751 13.2438 15.5247 13.3138 14.9145 13.9234L13.9642 14.8728C12.9338 14.2632 12.0534 13.5836 11.2531 12.7841C10.4929 12.0146 9.84261 11.1352 9.19237 10.1058L10.1127 9.0765ZM9.31242 7.59745C9.46247 7.8273 9.46247 8.16708 9.2724 8.31699L8.01193 9.61615C7.82186 9.80603 7.78184 10.0659 7.90189 10.2957C8.55213 11.5149 9.39245 12.6142 10.3828 13.6036C11.3732 14.5929 12.4836 15.4324 13.7041 16.082C13.9341 16.1919 14.2042 16.1619 14.3943 15.9721L15.6948 14.6829C15.9249 14.453 16.195 14.453 16.4151 14.6429L18.6259 16.4318C18.6259 16.4318 18.6659 16.4318 18.6659 16.4717C18.896 16.6616 18.896 17.0014 18.7059 17.2313L17.1453 18.7902C16.4251 19.5098 12.9138 17.651 9.59252 14.4131C6.30129 11.1352 4.47061 7.59745 5.23089 6.83794L6.79147 5.27894C7.02156 5.12904 7.4017 5.12904 7.59177 5.38887L9.31242 7.59745Z"
      :fill="color"
    />
  </svg>
</template>
